// getters
const restaurantProducts = state => state.restaurantProducts

export default {
  restaurantProducts
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/products/getters.js